exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.金融尬台語,div.金融尬台語口外{padding:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/Ogilvy/主題/金融尬台語.css
// module id = 671
// module chunks = 0